module.exports = __webpack_public_path__ + "static/media/find_closest.eecef73c.png";